import React, { Component } from "react";

class Contact extends Component {
  state = {};
  render() {
    return (
      <div className="container">
        <h1 className="page-header text-center head">Contact Us</h1>
        <div className="form-container">
          <div className="form-wrapper">
            <form className="form">
              <h4 className="contact-header">Contact Form</h4>
              <div className="name">
                <label>Name : </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your full name"
                ></input>
              </div>

              <div className="email">
                <label>Number : </label>
                <input
                  name="contact"
                  type="number"
                  placeholder="Enter your phone number"
                ></input>
              </div>

              <div className="email">
                <label>Email : </label>
                <input
                  name="email"
                  type="text"
                  placeholder="Enter your email"
                ></input>
              </div>

              <div className="message">
                <label>Message :</label>
                <textarea
                  name="message"
                  id="textarea"
                  cols="10"
                  rows="5"
                ></textarea>
              </div>

              <button className="contact-button">Submit</button>
            </form>
          </div>
          <div className="text-center">
            <h6 className="locate">Locate us</h6>
            <iframe
              title="location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31780.427110933208!2d-0.6491292604492124!3d5.332123900000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfde3530b2ea1165%3A0x87741e5ffcbe75c5!2sRhema%20Students%20Hostel%20-%20Winneba!5e0!3m2!1sen!2sgh!4v1633123394666!5m2!1sen!2sgh"
              width="600"
              height="450"
              // style="border:0;"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
